// ═══════════════════════════════════════════════════════════════
// API: Aprobaciones
// ═══════════════════════════════════════════════════════════════

import api from './config';

export const getPendientes = () =>
  api.get('/aprobaciones/pendientes').then(r => r.data);

export const getConteo = () =>
  api.get('/aprobaciones/conteo').then(r => r.data);

export const getHistorial = (params = {}) =>
  api.get('/aprobaciones/historial', { params }).then(r => r.data);
